<form [formGroup]="form" autocomplete="off">
    <ng-container [formArrayName]="formArraySelector">
        <div *ngFor="let control of observable | async; let i = index; trackBy: trackByName" [ngClass]="{ 'removable-input': control.removable }">
            <a
                *ngIf="control.removable"

                (click)="removeControl(i)"

                href="javascript:void(0);"
                class="icon-action-btn"
            >
                <i class="fa fa-minus-circle fa-sm text-danger"></i>
            </a>
            <div [ngSwitch]="control.componentType">
                <app-select
                    *ngSwitchCase="componentTypes.Select"
                    [formControlName]="i"
                    [control]="control"
                ></app-select>
                <app-radio-group
                    *ngSwitchCase="componentTypes.RadioGroup"
                    [formControlName]="i"
                    [control]="control"
                ></app-radio-group>
                <app-autocomplete
                    *ngSwitchCase="componentTypes.Autocomplete"
                    [formControlName]="i"
                    [control]="control"
                ></app-autocomplete>
                <app-phone-autocomplete
                    *ngSwitchCase="componentTypes.PhoneAutocomplete"
                    [formControlName]="i"
                    [control]="control"
                ></app-phone-autocomplete>
                <app-datepicker
                    *ngSwitchCase="componentTypes.Datepicker"
                    [formControlName]="i"
                    [control]="control"
                ></app-datepicker>
                <app-country-autocomplete
                    *ngSwitchCase="componentTypes.CountryAutocomplete"
                    [formControlName]="i"
                    [control]="control"
                ></app-country-autocomplete>
                <app-lockable-datepicker
                    *ngSwitchCase="componentTypes.LockableDatepicker"
                    [formControlName]="i"
                    [control]="control"
                    [leftAligned]="true"
                ></app-lockable-datepicker>
                <app-password-input
                    *ngSwitchCase="componentTypes.Password"
                    [formControlName]="i"
                    [control]="control"
                ></app-password-input>
                <app-panel-input
                    *ngSwitchDefault
                    [formControlName]="i"
                    [control]="control"
                ></app-panel-input>
            </div>

            <div *ngIf="!hiddenActions" class="text-center">
                <button type="submit" class="btn btn-sm btn-primary mr-3">Submit</button>
                <a href="javascript:void('0');" id="edit-cancel">Clear</a>
            </div>
        </div>
    </ng-container>
</form>
